import type { z } from "zod";

import type { navListV2Schema } from "./types";

export function isMenuPathActive(
  menuItem: z.infer<typeof navListV2Schema>,
  pathname: string
) {
  return menuItem.subMenu?.some((subMenuItem) =>
    subMenuItem.links.some((link) => link.url.includes(pathname))
  );
}
